<template>
  <div class="unbind-flow-app" data-automation="unbindFlowApp">
    <my-table
      class="x-margin-b"
      ref="table"
      xborder
      maxHeight="100%"
      :tableData="list"
      :columns="columns"
      :showPage="false"
    ></my-table>
    <my-footer-btn spacing="80px" padding="10px" hideConfirm @close="close"></my-footer-btn>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApply.name'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.unbind')],
                colors: ['#0087ff'],
                event: ['unbind']
              },
              on: {
                unbind: () => {
                  const title = this.$t('HT.unbind.title');

                  this.$uxModal.show({
                    title,
                    content: '',
                    confirm: () => {
                      let postData = {
                        id: this.data.id,
                        appId: params.app_id
                      };
                      this.unbind(postData);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      list: []
    };
  },
  created() {
    this.getInfoAppList(this.data.id);
  },
  methods: {
    close() {
      this.$uxModal.hide();
    },

    /**
     * 获取流量控制绑定的应用
     * @param {Number} id 唯一标识
     */
    getInfoAppList(id) {
      this.$uxLoading.show();
      this.$api.flow.getInfoAppList(id).then((res) => {
        if (res.code == 10000) {
          this.list = res.data;
        }
      });
    },

    /**
     * 解绑
     * @param {Object} params 对象
     */
    unbind(params) {
      this.$uxLoading.show();
      this.$api.flow.unbind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
          this.getInfoAppList(this.data.id);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.unbind-flow-app {
  width: 400px;
}
</style>
